import { ofType, type ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { AlertsActionsTypes, LoadAlertsFailure, LoadAlertsSuccess, type LoadAlerts } from './alerts.actions';
import { getAllAlerts } from './alerts.service';

const handleLoadAlerts = (action$: ActionsObservable<ReturnType<typeof LoadAlerts>>) =>
  action$.pipe(
    ofType(AlertsActionsTypes.LOAD_ALERTS),
    concatMap(() => getAllAlerts()),
    map(alerts => {
      return LoadAlertsSuccess(alerts);
    }),
    catchError((error: string) => of(LoadAlertsFailure(error)))
  );

export default handleLoadAlerts;
